let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f2Bey")).then(() => parcelRequire('fbaeV'));